// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__Table2 from "../../../molecules/Table/Table2.js";
import * as Buhta_cabinet__Timestamp from "../../../../util/Timestamp.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function Shifts(Props) {
  let id = Props.id;
  let shifts = Props.shifts;
  let maximizeShift = Props.maximizeShift;
  let orgId = Props.orgId;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, orgId, route);
  };
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  let isShiftOpen;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
    isShiftOpen = false;
  } else {
    switch (currentRoute.TAG) {
      case /* Org */ 6 :
        const match$1 = currentRoute._1;
        if (/* tag */ typeof match$1 === "number" || typeof match$1 === "string" || match$1.TAG !== /* Kassa */ 2) {
          isShiftOpen = false;
        } else {
          const match$2 = match$1._0._0;
          if (/* tag */ typeof match$2 === "number" || typeof match$2 === "string") {
            isShiftOpen = false;
          } else {
            const match$3 = match$2._1;
            if (/* tag */ typeof match$3 === "number" || typeof match$3 === "string" || match$3.TAG !== /* Journal */ 2) {
              isShiftOpen = false;
            } else {
              const match$4 = match$3._0;
              if (/* tag */ typeof match$4 === "number" || typeof match$4 === "string") {
                isShiftOpen = false;
              } else {
                let tmp = match$4._0;
                isShiftOpen = /* tag */ typeof tmp === "number" || typeof tmp === "string" || tmp.TAG !== /* View */ 0 ? false : true;
              }
            }
          }
        }
        break;
      case /* Admin */ 7 :
        const match$5 = currentRoute._0;
        if (/* tag */ typeof match$5 === "number" || typeof match$5 === "string" || match$5.TAG !== /* Orgs */ 1) {
          isShiftOpen = false;
        } else {
          const match$6 = match$5._0;
          if (/* tag */ typeof match$6 === "number" || typeof match$6 === "string") {
            isShiftOpen = false;
          } else {
            const match$7 = match$6._1;
            if (/* tag */ typeof match$7 === "number" || typeof match$7 === "string" || match$7.TAG !== /* Kassa */ 2) {
              isShiftOpen = false;
            } else {
              const match$8 = match$7._0._0;
              if (/* tag */ typeof match$8 === "number" || typeof match$8 === "string") {
                isShiftOpen = false;
              } else {
                const match$9 = match$8._1;
                if (/* tag */ typeof match$9 === "number" || typeof match$9 === "string" || match$9.TAG !== /* Journal */ 2) {
                  isShiftOpen = false;
                } else {
                  const match$10 = match$9._0;
                  if (/* tag */ typeof match$10 === "number" || typeof match$10 === "string") {
                    isShiftOpen = false;
                  } else {
                    let tmp$1 = match$10._0;
                    isShiftOpen = /* tag */ typeof tmp$1 === "number" || typeof tmp$1 === "string" || tmp$1.TAG !== /* View */ 0 ? false : true;
                  }
                }
              }
            }
          }
        }
        break;
      default:
        isShiftOpen = false;
    }
  }
  const header = {
    hd: {
      name: "#",
      style: ""
    },
    tl: {
      hd: {
        name: "Смена",
        style: ""
      },
      tl: {
        hd: {
          name: "Тип",
          style: ""
        },
        tl: {
          hd: {
            name: "Выручка",
            style: ""
          },
          tl: {
            hd: {
              name: "Наличные",
              style: ""
            },
            tl: /* [] */ 0
          }
        }
      }
    }
  };
  const header$1 = isShiftOpen ? header : Stdlib__List.append(header, {
      hd: {
        name: "Дата",
        style: "text-right"
      },
      tl: /* [] */ 0
    });
  const rows = Stdlib__List.mapi((function (i, shift) {
    const match = shift.report_type;
    let reportType;
    switch (match) {
      case /* REPORT_TYPE_UNSPECIFIED */ 0 :
        reportType = "Не указан";
        break;
      case /* REPORT_TYPE_X */ 1 :
        reportType = "X-отчет";
        break;
      case /* REPORT_TYPE_Z */ 2 :
        reportType = "Z-отчет";
        break;
    }
    const reportTime = DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(shift.report_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
    const shiftOpenTime = DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(shift.shift_open_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
    const shiftCloseTime = Belt__Belt_Option.map(shift.shift_close_time, (function (time) {
      return DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(time));
    }));
    const cells_0 = {
      body: String(shift.serial_id),
      style: ""
    };
    const cells_1 = {
      hd: {
        body: String(shift.shift_id),
        style: ""
      },
      tl: {
        hd: {
          body: reportType,
          style: ""
        },
        tl: {
          hd: {
            body: MelNumeral.format({
              NAME: "Str",
              VAL: shift.revenue_amount
            }),
            style: ""
          },
          tl: {
            hd: {
              body: MelNumeral.format({
                NAME: "Str",
                VAL: shift.cash_amount
              }),
              style: ""
            },
            tl: /* [] */ 0
          }
        }
      }
    };
    const cells = {
      hd: cells_0,
      tl: cells_1
    };
    const cells$1 = isShiftOpen ? cells : Stdlib__List.append(cells, {
        hd: {
          body: shiftCloseTime !== undefined ? shiftOpenTime + (" — " + shiftCloseTime) : reportTime,
          style: "justify-end"
        },
        tl: /* [] */ 0
      });
    const Key = String(i);
    return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
      cells: cells$1,
      route: contextRoute({
        TAG: /* Kassa */ 2,
        _0: {
          TAG: /* Kkms */ 0,
          _0: {
            TAG: /* Kkm */ 0,
            _0: id,
            _1: {
              TAG: /* Journal */ 2,
              _0: {
                TAG: /* Shifts */ 0,
                _0: {
                  TAG: /* View */ 0,
                  _0: shift.id
                }
              }
            }
          }
        }
      })
    }, Key);
  }), shifts);
  return JsxRuntime.jsx("div", {
    children: Stdlib__List.length(shifts) > 0 ? JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
        header: header$1,
        rows: rows,
        styles: Cn.$plus(Cn.$plus("grid overflow-x-auto px-4 py-6 lg:p-0", Cn.on("grid-cols-shifts-max", !isShiftOpen)), Cn.on("grid-cols-5", isShiftOpen))
      }) : JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-10 h-10",
            src: StaticAsset.src("/static/icons/cashier-40.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "mt-6 text-default-gray",
            children: "Нет смен"
          })
        ],
        className: "flex flex-col items-center col-span-6 mt-84"
      }),
    className: Cn.$plus("flex-1 overflow-y-auto", Cn.on("hidden", maximizeShift || deviceType === "mobile" && isShiftOpen))
  });
}

const make = Shifts;

export {
  make,
}
/* Buhta_cabinet__Route Not a pure module */
